import { render, staticRenderFns } from "./CardHeader.vue?vue&type=template&id=2812a4bd&scoped=true"
import script from "./CardHeader.vue?vue&type=script&lang=js"
export * from "./CardHeader.vue?vue&type=script&lang=js"
import style0 from "./CardHeader.vue?vue&type=style&index=0&id=2812a4bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2812a4bd",
  null
  
)

export default component.exports